<template>
  <!-- 媒体展示 -->
  <div v-if="isopen" class="vaidio">
    <div class="canter">
      <img
        v-if="typefile == 'img'"
        class="img"
        :style="`transform: rotateZ(${rotate}deg)`"
        :src="file"
        alt=""
      />
      <video v-else controls class="img" :src="file" alt="" />
      <div class="btn">
        <el-button
          class="mb2"
          type="primary"
          plain
          size="default"
          @click="spinFn"
        >
          旋转
        </el-button>
        <br />
        <el-button type="primary" size="default" @click="openfn">
          关闭
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'Vaidio',
  components: {},
  data() {
    return {
      rotate: 0,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'img',
    },
    detail: {
      type: String,
    },
  },
  computed: {
    file() {
      return this.detail
    },
    typefile() {
      return this.type
    },
    isopen() {
      return this.value
    },
  },
  methods: {
    openfn() {
      this.$emit('input', false)
    },
    spinFn() {
      this.rotate += 90
    },
  },
}
</script>

<style scoped lang="scss">
.mb2 {
  margin-bottom: 15px;
}
.vaidio {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  .canter {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .img {
    width: 40%;
    object-fit: contain;
    transition: all 0.25s;
  }
  .btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
</style>
